<template>
    <div class="container">
        <!-- Bio Details -->
        <div class="row my-5">
            <div class="col-12">
                <div class="card bg-light">
                    <div class="card-body">
                        <form v-if="user">
                            <dl class="row">
                                <dt class="col-lg-8 col-md-7 col-sm-6 col-12">
                                    <h3 class="text-dark-green nav-settings-head">Edit Profile</h3>
                                </dt>
                                <dd class="col-lg-4 col-md-5 col-sm-6 col-12 d-none d-sm-block">
                                    <div class="row">
                                        <div class="col-5">
                                            <router-link :to="{ name: 'profile' }" class="btn btn-light btn-sm bg-white form-control">Go Back</router-link>
                                        </div>
                                        <div class="col-7">
                                            <button @click.prevent="saveBio" class="loadn btn btn-dark-green btn-sm form-control">Save Changes</button>
                                        </div>
                                    </div>
                                </dd>
                                <dd class="col-12"><small>Your contact info is visible to you alone! We care about your privacy.</small></dd>
                            </dl>
                            <dl v-if="msg !== ''" class="row mb-5">
                                <dd class="col-12">
                                    <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                                    </div>
                                </dd>
                            </dl>
                            <dl class="row">
                                <dt class="col-sm-3">Full Name<span class="text-danger">*</span></dt>
                                <dd class="col-sm-9"><p><input type="text" v-model="name" :placeholder="user.name | capitalize" class="form-control no-lines"></p></dd>

                                <dt class="col-sm-3">Bio</dt>
                                <dd class="col-sm-9">
                                    <p>
                                        <textarea v-model="bio" @keyup="bioCount" type="text" class="form-control no-lines" rows="3" placeholder="brief info about your shop for your buyers"></textarea>
                                        <small v-if="bioLength" class="text-dark-green" v-bind:class="{ 'text-danger' : bioLength > bioLimit }">Bio characters: ({{bioLength}}/{{bioLimit}})</small>
                                    </p>
                                </dd>

                                <dt class="col-sm-3">Birthday</dt>
                                <dd class="col-sm-3">
                                    <select v-model="day" class="custom-select no-lines" style="border-color: #DFDFDF;">
                                        <option disabled value="">{{birthday}}</option>
                                        <option v-for="(x, i) in 31" :key="i" :value="x">{{x}}</option>
                                    </select>
                                </dd>
                                <dd class="col-sm-3">
                                    <select v-model="month" class="custom-select no-lines" style="border-color: #DFDFDF;">
                                        <option disabled value="">{{birthmonth}}</option>
                                        <option v-for="(x, i) in months" :key="i" :value="x">{{x}}</option>
                                    </select>
                                </dd>
                                <dd class="col-sm-3">
                                    <select v-model="year" class="custom-select no-lines" style="border-color: #DFDFDF;">
                                        <option disabled value="">{{birthyear}}</option> 
                                        <option v-for="(x, i) in years" :key="i" :value="x">{{x}}</option>
                                    </select>
                                </dd>

                                <dt class="col-sm-3 m-0">&nbsp;</dt>
                                <dd class="col-sm-9 m-0">
                                    <small>Your birthday is not public, it's visible to you alone.</small>
                                </dd>
                            </dl>
                            <hr>
                            <dl class="row">
                                <dt class="col-sm-3">Email<span class="text-danger">*</span></dt>
                                <dd class="col-sm-9"><p><input type="email" :placeholder="user.email" readonly class="form-control no-lines"></p></dd>

                                <dt class="col-sm-3">Phone</dt>
                                <dd class="col-sm-9">
                                    <div class="mb-3">
                                        <div v-if="previewPhone" class="my-1 p-1 text-dark-green bg-white">
                                            <i class="fas fa-phone-alt fa-sm"></i> Your Phone No.: {{user.phoneCode}}{{phone}}
                                        </div>
                                        <div class="input-group">
                                            <div v-if="user.phoneCode" class="input-group-prepend">
                                                <div class="input-group-text bg-light"><i :class="`flag flag-${user.alphaCode} mr-2`"></i>{{user.phoneCode}}</div>
                                            </div>
                                            <input type="text" v-model="phone" @keyup="previewPhone = true" placeholder="phone number" class="form-control no-lines">
                                        </div>
                                        <small>
                                            You'll be notified of interested buyers on it. <span class="text-danger">Shouldn't contain spaces or symbols</span>.
                                            It's visible to the public. <span @click="gotoPrivacyPage" class="text-dark-green clickable">Privacy Settings</span>. 
                                        </small>
                                    </div>
                                </dd>

                                <dt class="col-sm-3">Socials</dt>
                                <dd class="col-sm-9">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-6 col-sm-12">
                                            <div class="input-group mb-2">
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text bg-light text-info"><i class="fab fa-twitter"></i></div>
                                                </div>
                                                <input type="text" v-model="twitter" placeholder="handle" class="form-control no-lines">
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-sm-12">
                                            <div class="input-group mb-2">
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text bg-light text-danger"><i class="fab fa-instagram"></i></div>
                                                </div>
                                                <input type="text" v-model="instagram" placeholder="username" class="form-control no-lines">
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-sm-12">
                                            <div class="input-group mb-2">
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text bg-light text-primary"><i class="fab fa-facebook"></i></div>
                                                </div>
                                                <input type="text" v-model="facebook" placeholder="username" class="form-control no-lines">
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 col-sm-12">
                                            <div class="input-group mb-2">
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text bg-light"><div class="fab-anewitem">a</div></div>
                                                </div>
                                                <input @click="gotoHandlePage" type="text" :value="user.userHandle" placeholder="handle" class="form-control no-lines">
                                            </div>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <hr>
                            <dl class="row">
                                <dt class="col-sm-3 col-12">Photos</dt>
                                <dd class="col-sm-9 col-12">
                                    <div class="row">
                                        <div class="col-sm-6 col-12">
                                            <button @click.prevent="changeDisplayPhoto = true" class="btn btn-secondary form-control my-1">
                                                <i class="far fa-edit"></i> Profile photo
                                            </button>
                                        </div>
                                        <div class="col-sm-6 col-12">
                                            <button @click.prevent="changeCoverPhoto = true" class="btn btn-secondary form-control my-1">
                                                <i class="far fa-edit"></i> Cover photo
                                            </button>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <dl class="row d-sm-none">
                                <dd class="col-12">
                                    <hr>
                                    <div class="row">
                                        <div class="col-6">
                                            <router-link :to="{ name: 'profile' }" class="btn btn-light btn-sm bg-white form-control">Go Back</router-link>
                                        </div>
                                        <div class="col-6">
                                            <button @click.prevent="saveBio" class="loadn btn btn-dark-green btn-sm form-control">Save Changes</button>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- show change display photo -->
        <app-change-photo v-if="changeDisplayPhoto" kind="display"></app-change-photo>

        <!-- show change cover photo -->
        <app-change-photo v-if="changeCoverPhoto" kind="cover"></app-change-photo>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

import ChangePhoto from './ChangePhoto.vue'

export default {
    name: "BioData",
    data() {
        return {
            changeDisplayPhoto: false,
            changeCoverPhoto: false,
            previewPhone: false,
            selected: '',
            name: '',
            bioLength: 0,
            bioLimit: 250,
            bio: '',
            day: '',
            months: [
                'january','febuary','march','april','may','june',
                'july','august','september','october','november','december'
            ],
            month: '',
            year: '',
            phone: '',
            twitter: '',
            instagram: '',
            facebook: '',
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['updateProfile']),
        saveBio(){
            this.color = "danger"
            if(this.bio !== ''){
                if(this.bio.length > this.bioLimit){
                    this.msg = `Bio cannot be more than ${this.bioLimit} characters!`
                    return
                }
            }
            let userObj = {
                userId: this.user._id,
                name: this.name.toLowerCase(),
                phone: this.removePlusSign(this.phone),
                bio: this.bio,
                day: this.day,
                month: this.month,
                year: this.year,
                twitter: this.removeAtSign(this.twitter),
                instagram: this.removeAtSign(this.instagram),
                facebook: this.removeAtSign(this.facebook)
            }
            this.updateProfile(userObj)
            .then(() => {
                this.color = "success"
                this.msg = "Changes successfully saved!"
                this.bio = ""
                this.phone = ""
                this.twitter = ""
                this.facebook = ""
                this.instagram = ""
                this.previewPhone = false
                this.assignValues()
            }).catch((e) => {
                this.msg = "Saving changes failed, try again."
            })
        },
        removeAtSign(val) {
            // ensure it doesn't begin with @ sign
            val = val.toLowerCase()
            let atSymbol = val.slice(0, 1) 
            if(atSymbol !== '@'){ return val }
            else { return val.slice(1, val.length) }
        },
        removePlusSign(val) {
            // ensure it doesn't begin with + sign
            let thePhoneCode = this.user.phoneCode ? `${this.user.phoneCode}` : '+'
            val = val.toLowerCase()
            let plusSymbol = val.slice(0, thePhoneCode.length) 
            // remove country phone code if any
            if(plusSymbol == `${this.user.phoneCode}`){ 
                return val.slice(thePhoneCode.length, val.length) 
            }
            // remove plus sign if any
            else if(val.slice(0, 1) == "+") {
                return val.slice(1, val.length) 
            }
            // return the phone number without modifying it
            else { 
                return val 
            }
        },
        bioCount() {
            return this.bioLength = this.bio.length
        },
        gotoHandlePage () {
            this.$router.push({
                name: 'settings',
                query: { handle: null }
            }).catch((e) => {})
            this.$emit('gotoHandle', true)
        },
        gotoPrivacyPage () {
            this.$router.push({
                name: 'settings',
                query: { privacy: null }
            }).catch((e) => {})
            this.$emit('gotoPrivacy', true)
        },
        assignValues() {
            if(this.user.bio){ this.bio = this.user.bio }
            if(this.user.name){ this.name = this.user.name }
            if(this.user.phone){ this.phone = this.user.phone }
            if(this.user.twitter){ this.twitter = this.user.twitter }
            if(this.user.facebook){ this.facebook = this.user.facebook }
            if(this.user.instagram){ this.instagram = this.user.instagram }
        },
    },
    computed: {
        ...mapGetters(['user', 'authenticated']),
        years() {
            let newArr = []
            // allow people between ages of 15 - 80 use this app
            let youngestYear = new Date().getFullYear() - 15
            let oldestYear = new Date().getFullYear() - 80
            for (let x = oldestYear; x <= youngestYear; x++) {
                newArr.unshift(x)
            }
            return newArr
        },
        birthday() {
            if(this.user.day){
                return this.user.day
            }
            return 'day'
        },
        birthmonth() {
            if(this.user.month){
                return this.user.month
            }
            return 'month'
        },
        birthyear() {
            if(this.user.year){
                return this.user.year
            }
            return 'year'
        }
    },
    components: {
        appChangePhoto: ChangePhoto,
    },
    mounted() {
        this.assignValues()
        this.$router.push('?bio').catch((e) => {})
    },
    created() {
        eventBus.$on('hideGhostMode', (value) => {
            this.changeCoverPhoto = value;
            this.changeDisplayPhoto = value;
        })
    }
}
</script>